import { serializeStyles } from '../../serialize/dist/serialize.browser.esm.js';

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

export { css as default };
